Object.defineProperty(exports, '__esModule', {
  value: true
});
const DEFAULT_ENVIRONMENT = 'production';
exports.DEFAULT_ENVIRONMENT = DEFAULT_ENVIRONMENT;